import {Nps} from "../Nps";
import ICustomForm from "../../ICustomForm";
import ICustomFormSettings from "../../ICustomFormSettings";
import NumericScaleItem from "../../shared/components/NumericScaleItem/NumericScaleItem";

export default class NpsDefault extends Nps implements ICustomForm
{
    constructor(setting: ICustomFormSettings) {
        super(setting);

        const initFocused = String(setting.form.aux1 ?? '6'); // default value 6, label 5

        this.npsItem = new NumericScaleItem(
            this.radioItems,
            this.labels,
            initFocused // default value 6, label 5
        );
    }
}